import { ForwardedRef, forwardRef, ReactNode } from "react";
import {
  Badge,
  BadgeProps,
  Box,
  BoxProps,
  Flex,
  FlexProps,
} from "@chakra-ui/react";

type Props = FlexProps & {
  label: ReactNode;
  labelProps?: BadgeProps;
  value: ReactNode;
  valueProps?: BoxProps;
};
function LabeledValueBadge(
  { label, labelProps, value, valueProps, ...rest }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <Flex
      ref={ref}
      display="inline-flex"
      borderWidth={1}
      borderRadius="sm"
      sx={{ "tr[aria-selected]:hover &": { borderColor: "gray.300" } }}
      maxW="100%"
      fontSize=".85em"
      {...rest}
    >
      <Badge borderRadius={0} fontSize=".75em" flex="0 0 auto" {...labelProps}>
        {label}
      </Badge>
      <Box as="span" isTruncated minW="1em" px=".3em" {...valueProps}>
        {value}
      </Box>
    </Flex>
  );
}

export default forwardRef(LabeledValueBadge);
